// extracted by mini-css-extract-plugin
module.exports = {"turboSpinnerLoader":"_35O5X","loading":"ar4Ga"};